import {useIntl} from 'react-intl'
import {KTSVG} from '../../../helpers'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'
import {shallowEqual, useSelector} from 'react-redux'
import {UserModel} from '../../../../app/modules/auth/models/UserModel'
import {RootState} from '../../../../setup'

export function AsideMenuMain() {
  const intl = useIntl()
  const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
  return (
    <>
      <AsideMenuItem
        to='/dashboard'
        icon='/media/icons/duotune/art/art002.svg'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon='bi-app-indicator'
      />
      {/* //==================== Location ===================== */}
      <AsideMenuItemWithSub
        to='/locations'
        title='Locations'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen025.svg'
      >
        <AsideMenuItem to='/locations/country' title='Country' hasBullet={true} />
        <AsideMenuItem to='/locations/state' title='State' hasBullet={true} />
        <AsideMenuItem to='/locations/city' title='City' hasBullet={true} />
        {/* <AsideMenuItem to='/locations/areapincode' title='Area Pincode' hasBullet={true} />
        <AsideMenuItem to='/locations/society' title='Society' hasBullet={true} />
        <AsideMenuItem to='/locations/pickup-drop-point' title='Kiosk Point' hasBullet={true} />
        <AsideMenuItem to='/locations/service-center' title='Service Center' hasBullet={true} /> */}
      </AsideMenuItemWithSub>

      <AsideMenuItem
        to='/service'
        icon='/media/icons/duotune/general/gen015.svg'
        title='Our Service'
        fontIcon='bi-layers'
      />
      <AsideMenuItem
        to='/inquiry'
        icon='/media/icons/duotune/general/gen017.svg'
        title='Inquiry'
        fontIcon='bi-layers'
      />

      {/* <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Menu</span>
        </div>
      </div> */}

      {/* ********************************************************************************************************** */}

      <AsideMenuItemWithSub
        to='/master'
        title='Master'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen022.svg'
        // dislpay={user.roleID === 4 ? 'd-none' : ''}
      >
        {/* <AsideMenuItem to='/master/country' title='Country' hasBullet={true} /> */}
        {/* <AsideMenuItem
          to='/master/service-subcategory'
          title='Service Sub Category'
          hasBullet={true}
        /> */}
        <AsideMenuItem to='/master/album' title='Album' hasBullet={true} />
        <AsideMenuItem to='/master/album-media' title='Album Media' hasBullet={true} />
        <AsideMenuItem to='/master/bannerimage' title='Banner Image' hasBullet={true} />
        <AsideMenuItem to='/master/blog' title='Blog' hasBullet={true} />
        {/* <AsideMenuItem to='/master/customer' title='Customer' hasBullet={true} /> */}
        <AsideMenuItem to='/master/event' title='Event' hasBullet={true} />
        <AsideMenuItem to='/master/donation' title='Service' hasBullet={true} />
        {/* <AsideMenuItem to='/master/vendor' title='Vendor' hasBullet={true} /> */}
        <AsideMenuItem to='/master/designation' title='Designation' hasBullet={true} />
        <AsideMenuItem to='/master/documenttype' title='Document Type' hasBullet={true} />
        <AsideMenuItem to='/master/eduCategory' title='Education Category' hasBullet={true} />
        <AsideMenuItem to='/master/eduDepartment' title='Education Department' hasBullet={true} />
        <AsideMenuItem to='/master/nationality' title='Nationality' hasBullet={true} />
        {/* <AsideMenuItem to='/master/kycdocument' title='Kyc Document' hasBullet={true} /> */}
        {/* <AsideMenuItem to='/master/homevideo' title='Home Video' hasBullet={true} /> */}
      </AsideMenuItemWithSub>
      {/* ---------------------------- Products ---------------- */}
      <AsideMenuItemWithSub
        to='/product-manage'
        title='Product Manage'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen019.svg'
      >
        {/* <AsideMenuItem to='/product-manage/service-category' title='Service' hasBullet={true} /> */}
        <AsideMenuItem
          to='/product-manage/item-category'
          title='Product Category'
          hasBullet={true}
        />
        <AsideMenuItem to='/product-manage/items' title='Product' hasBullet={true} />
        {/* <AsideMenuItem to='/master/laundry-type' title='Laundry Type' hasBullet={true} />
        <AsideMenuItem to='/product-manage/driver-tip' title='Driver Tip' hasBullet={true} /> */}
      </AsideMenuItemWithSub>

      {/* //============== Organization ================================= */}
      <AsideMenuItemWithSub
        to='/organization'
        title='Organization'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen025.svg'
        // dislpay={user.roleID === 4 ? 'd-none' : ''}
      >
        <AsideMenuItem to='/organization/employee' title='Employee' hasBullet={true} />
        <AsideMenuItem to='/organization/user' title='User' hasBullet={true} />
        {/* <AsideMenuItem to='/organization/customer' title='Customer' hasBullet={true} /> */}
      </AsideMenuItemWithSub>

      <AsideMenuItemWithSub
        to='/purchase-management'
        title='Purchase Manage'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen059.svg'
        // dislpay={user.roleID === 4 ? 'd-none' : ''}
      >
        <AsideMenuItem to='/purchase-management/vendor' title='Vendor' hasBullet={true} />
        <AsideMenuItem to='/purchase-management/purchase' title='Purchase' hasBullet={true} />
      </AsideMenuItemWithSub>
      <AsideMenuItemWithSub
        to='/sales-management'
        title='Sales Manage'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen049.svg'
        // dislpay={user.roleID === 4 ? 'd-none' : ''}
      >
        <AsideMenuItem to='/sales-management/customer' title='Customer' hasBullet={true} />
        <AsideMenuItem to='/sales-management/sale' title='Sale' hasBullet={true} />
      </AsideMenuItemWithSub>

      <AsideMenuItemWithSub
        to='/report'
        title='Report'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen057.svg'
        // dislpay={user.roleID === 4 ? 'd-none' : ''}
      >
        <AsideMenuItem to='/report/stock-report' title='Stock Report' hasBullet={true} />
      </AsideMenuItemWithSub>
      {/* <AsideMenuItem
        to='/sale'
        icon='/media/icons/duotune/general/gen049.svg'
        title='Sale'
        fontIcon='bi-layers'
      />
      <AsideMenuItem
        to='/purchase'
        icon='/media/icons/duotune/general/gen059.svg'
        title='Purchase'
        fontIcon='bi-layers'
      /> */}
    </>
  )
}
